/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

const Circle = (props) => (
  <svg
    height={`${props.size}`}
    width={`${props.size}`}
    preserveAspectRatio="xMidYMid meet"
    style={props.style}
  >
    <circle className={props.className} cx="50%" cy="50%" r={(props.size - props.strokeWidth) / 2} style={{ strokeWidth: `${props.strokeWidth}px` }} />
  </svg>
);
Circle.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
  strokeColor: PropTypes.string,
  fillColor: PropTypes.string,
  strokeWidth: PropTypes.number,
  style: PropTypes.object,
};
Circle.defaultProps = {
  strokeWidth: 0,
};

export default Circle;
